import { render, staticRenderFns } from "./ChangeMembershipConfirm.vue?vue&type=template&id=fc0ddb24&"
import script from "./ChangeMembershipConfirm.vue?vue&type=script&lang=ts&"
export * from "./ChangeMembershipConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports